import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-time-sheets',
  templateUrl: './time-sheets.component.html',
  styleUrls: ['./time-sheets.component.css']
})
export class TimeSheetsComponent implements OnInit {
    labourNo;

    public itemsListTimeSheets: Item[] = [];

    constructor(private datatask: DataTaskService, private stateService: StateService) {
        this.labourNo = this.stateService.getStateParams()['labour_no'];
    }

    private async loadTimeSheets() {
        if (!!this.labourNo) {
            this.itemsListTimeSheets = await this.datatask.Post(123, { labour_no: this.labourNo });
        }
    }

    private async init() {
        this.loadTimeSheets();
    }

    ngOnInit() {
        this.init();
    }
}
